import { Routes, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

import { ReactIntegration, ReactRouterVersion, getWebInstrumentations, initializeFaro } from "@grafana/faro-react";
import { FetchTransport } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

const envPrefixMatch = /((\w+)(-))?cap-rx[.]com/.exec(window.location.hostname);
const isLocal = envPrefixMatch === null;
const collectorUrl =
  envPrefixMatch !== null ? `https://alloy.${envPrefixMatch[1] ?? ""}cap-rx.com:12347/collect` : "http://127.0.0.1:12347/collect";

export const faro = initializeFaro({
  transports: !isLocal
    ? [
        new FetchTransport({
          url: collectorUrl,
          requestOptions: {
            keepalive: true,
          },
        }),
      ]
    : [],
  app: {
    name: "adjudication",
    version: "1.0.0",
    environment: envPrefixMatch !== null ? envPrefixMatch[2] : "local",
  },
  instrumentations: [
    ...(!isLocal
      ? [
          ...getWebInstrumentations({
            captureConsole: true,
          }),
          new TracingInstrumentation(),
        ]
      : []),
    new ReactIntegration({
      router: {
        version: ReactRouterVersion.V7,
        dependencies: {
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType,
        },
      },
    }),
  ],
});
